import { ICompanyModel } from "./company/company.model";
import { IUserModel } from "./user/user.model";

export const useUser:()=>IUserModel = require("./user/user.model").default;
export const useCompany:()=>ICompanyModel = require("./company/company.model").default;